import { ApiContextType } from '../api-context';
import { ReferrerResponse, Referrer } from '../typings';

export const fetchReferrers = (api: ApiContextType): Promise<Referrer[]> => {
    return api.post(`/referrers`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchReferrer = (api: ApiContextType, id: number): Promise<ReferrerResponse> => {
    return api.get(`/referrer/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};



